import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-idle-dialog',
  templateUrl: './idle-dialog.component.html',
  styleUrls: ['./idle-dialog.component.css']
})
export class IdleDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<IdleDialogComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: { message: string }
  ) {}

  continueApplication() {
    this.dialogRef.close();
  }
}
